import { v4 as uuid } from "uuid";

let wgid = "";
let iframeDom = {} as HTMLIFrameElement;
/**
 * 同步主站(designkit.com)的wgid
 *
 * @return {*}  {Promise<string>}
 * const deviceId = await getUnionDeviceId();
 */
export function getUnionDeviceId(): Promise<string> {
     const gid = window.mtstat?.getStatsMarker?.() || '';
     return gid
}

/**
 * 循环取gid, 如果1s内没取到就随机生成(可能遇到埋点web sdk初始化失败)
 * @returns Promise<string>  返回gid
 */
export const waitUntilGetGid = (): Promise<string> => {
  return new Promise((resolve) => {
    if (wgid) {
      resolve(wgid);
      return;
    }

    let loopTimes = 4;
    const getData = async () => {
      wgid = await getUnionDeviceId();
      if (!wgid && loopTimes === 0) {
        wgid = uuid();
        resolve(wgid);
      } else if (!wgid) {
        setTimeout(() => {
          loopTimes = loopTimes - 1;
          getData();
        }, 500);
      } else {
        resolve(wgid);
      }
    };

    getData();
  });
};
